const typeInfoConfiguration = Object.freeze({
  LeaseList: 1,
  LeasePopup: 2,
  LandList: 3,
  LandPopup: 4,
  SalesList: 5,
  SalesPopUp: 6,
  ComercialLeasePopupParent: 7,
  ComercialLeasePopupChild: 8,
  ComercialLeaseList: 9,
  IEList: 10,
  IEPopup: 11,
});

export default typeInfoConfiguration;
